import * as array from 'd3-array'
import * as scale from 'd3-scale'
import * as decorations from './decorations'
import container from './container'
import * as util from 'infographic-util'
import * as d3 from 'd3-selection'
import { tilt } from './drawing'

// The conteiner should be rotated slighty less than the liquid
const containerRotationAdjustment = -1

import basic from './animations/basic-animation'

export const animations = [
  basic
]

export const preAnimate = function (chart, selection, series) {
  let seriesData = series.selection().data()
    , grid = chart.layout.getGrid(chart.datum().dimensions)
    , axes = chart.datum().axes
    , titleHeight = 0
    , colors = new Set
    , defs = d3.select(selection.node().ownerSVGElement).select('defs')
    , formatter = chart.layout.getFormatter('infographic')

  if (util.title(grid.blocks, grid.blocks[0], seriesData)) {
    titleHeight += 22 // TODO Magic
  }

  let beakers = grid.blocks.map(block => {
    // Grab the the point for each series
    let points = seriesData.map(serie => {
        let point = util.getPoint(block.range.id, serie)
        colors.add(point.color)
        return point
      })
      , total = util.total(axes, points[points.length - 1]._range[1])
      , title = util.title(grid.blocks, block, seriesData)
      , width = block.dimensions.width

    if (grid.width / grid.height > 4 / 2) {
      // This is way too wide to look good. Restrict the width
      width = grid.height * 2
    }

    let ry = (width / 2) * tilt + containerRotationAdjustment
      , height = (block.dimensions.height - titleHeight) - ry * 2 // full height

    return {
      chartId: chart.id,
      title,
      block,
      total,
      formatter,
      points,
      ry,
      height,
      width,
      scale: scale.scaleLinear()
                  .domain([0, total])
                  .range([height, 0]) // subtract padding for the bottom arc
    }
  })

  // Add the outlines used for all beakers. These aren't unique to
  // sizes, locations, etc.
  defs.call(decorations.default, Array.from(colors), chart.id)

  selection.call(container, chart, beakers, defs)
}
